<template>
  <lb-drawer
    :value="visible"
    @input="$emit('update:visible', $event)"
    heading="Edit Due Date"
    width="500"
    v-if="visible"
    data-testid="tasklist__bulk-due-date-drawer"
  >
    <template v-slot:body>
      <div
        class="d-flex align-center dataCount gap-120 mb-3"
        data-testid="tasklist__bulk-due-date-count-section"
      >
        <h6
          class="font-weight-medium count-label"
          data-testid="tasklist__bulk-due-date-count-label"
        >
          Selected Task
        </h6>
        <h3 class="font-weight-medium" data-testid="tasklist__bulk-due-date-count-value">
          {{ selectedTasks.length }}
        </h3>
      </div>
      <p class="mb-1 mt-3 gray--text">Due Date</p>
      <lb-date
        hidedetails
        label=""
        placeholder="Select due date"
        :value="dueDate"
        @input="$emit('update:dueDate', $event)"
        class="mt-2"
        width="10"
        :min="minDate"
        :max="maxDate"
        data-testid="tasklist__bulk-due-date-picker"
      />
      <span class="font-size-xm gray--text">
        Due date must be within {{ maxDueDateDays }} days from today.
      </span>
      <p class="mb-1 mt-4 gray--text">Note (optional)</p>
      <v-textarea
        :value="note"
        @input="$emit('update:note', $event)"
        outlined
        dense
        hide-details
        rows="3"
        maxlength="200"
        counter="200"
        placeholder="Reason for due date change"
        data-testid="tasklist__bulk-due-date-note"
      />
    </template>
    <template v-slot:actions>
      <v-spacer />
      <v-btn
        color=""
        class="black white--text"
        :loading="loading"
        data-testid="tasklist__bulk-due-date-drawer-update-btn"
        @click="$emit('confirm')"
      >
        <span>Update</span>
      </v-btn>
    </template>
  </lb-drawer>
</template>

<script>
import './BulkUpdateDueDateDrawer.scss';
import { MAX_DUE_DATE_DAYS } from '../../utils/constants';

export default {
  name: 'BulkUpdateDueDateDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedTasks: {
      type: Array,
      default: () => [],
    },
    dueDate: {
      type: String,
      default: '',
    },
    note: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: String,
      default: '',
    },
    maxDate: {
      type: String,
      default: '',
    },
  },
  computed: {
    maxDueDateDays() {
      return MAX_DUE_DATE_DAYS;
    },
  },
};
</script>
